export default __webpack_public_path__ + "static/media/pvilla7-2.e4e01452.webp";